<div
  class="input-area-wrapper input-area-wrapper-close"
  style="align-items: flex-start"
>
  <label for="nameInput" class="select-label">
    {{ label() }}
    @if (required()) {
      <span class="purple-alert-text"> *</span>
    }
  </label>

  <div
    class="input-area input-close"
    [class.error-input]="
      !isNameValid() && !warnNameDuplicate() && nameModel?.touched
    "
    [class.warning-input]="
      !isNameValid() && warnNameDuplicate() && nameModel?.touched
    "
  >
    <input
      #nameInput
      #nameModel="ngModel"
      [ngModel]="name() | sanitizeInput"
      (ngModelChange)="onInputChange($event)"
      [maxlength]="35"
      [class.wide-input]="wideInput()"
      [disabled]="disabled()"
      name="nameInput"
      [ngClass]="name().includes('/') ? 'inputBorderAlert icons:info' : ''"
      [placeholder]="placeholder()"
    />

    @if (name().includes("/")) {
      <div class="alert-icon">
        <i nz-icon [nzType]="'icons:alert-icon'" class="svg-icon"></i>
      </div>
    }

    <div
      class="display-alert-msg"
      [ngClass]="name().includes('/') ? 'redAlert' : ''"
    >
      <i
        nz-icon
        [nzType]="
          name().includes('/') ? 'icons:cross-circle' : 'icons:done-full-circle'
        "
        class="svg-icon alert-error-icon"
      ></i>
      {{ i18n.langString("special_Characters_Not_Allowed") }}
    </div>

    <div class="display-alert-msg">
      <i
        nz-icon
        [nzType]="'icons:done-full-circle'"
        class="svg-icon alert-error-icon"
      ></i>
      {{ i18n.langString("not_more_than_35_chars") }}
    </div>

    @if (!isNameValid() && (nameModel?.dirty || nameModel?.touched)) {
      <i
        nz-icon
        [nzType]="'icons:exclamation-mark-filled'"
        class="error-icon"
        [ngClass]="warnNameDuplicate() ? 'fillred' : 'fillyellow'"
      ></i>
    }
  </div>

  @if (
    !isNameValid() &&
    !warnNameDuplicate() &&
    (nameModel?.dirty || nameModel?.touched)
  ) {
    <div class="blockHint body-bold warning-hint">
      <nz-icon nzType="exclamation-circle" nzTheme="outline" />
      {{ i18n.langString("name_warning") }}
    </div>
  }

  @if (
    !isNameValid() &&
    warnNameDuplicate() &&
    (nameModel?.dirty || nameModel?.touched)
  ) {
    <div class="blockHint body-bold error-hint">
      <i
        nz-icon
        nzType="icons:exclamation-mark-filled"
        class="svg-icon fillwhite"
      ></i>
      {{ i18n.langString("name_error") }}
    </div>
  }
</div>
